<template>
  <div class="wspo-icon-container">
    <div class="wspo-icon-sprite" v-for="icon in icons" :id="icon" :key="icon">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Includes',
  props: {
    // type: String,
    data: [Object, null]
  },
  computed: {
    rating() {
      return this.data.lt_rate
        ? this.data.lt_rate
        : this.data.tv_rate
          ? this.data.tv_rate * 2
          : 0;
    },
    icons() {
      const ids = [];
      if (this.data.earlybooking === 'EARLYBOOKING') ids.push('rannee');
      else if (this.data.earlybooking === 'NEWYEAR') ids.push('newyear');
      if (this.data.include === 'AVIA')
        ids.push('projivanie', 'perelet', 'strahovka', 'transfer');
      else if (this.data.include === 'ZHD')
        ids.push('projivanie', 'train', 'strahovka', 'transfer');
      else if (this.data.include === 'BUS')
        ids.push('projivanie', 'bus', 'transfer');
      else if (this.data.include === 'LIVEMOVE')
        ids.push('projivanie', 'transfer');
      else if (this.data.include === 'LIVE') ids.push('projivanie');
      if (this.data.excursions === 'excurYes') ids.push('ekskursii');
      else if (this.data.excursions === 'NYParty') ids.push('newyearprogram');

      switch (this.data.feed) {
        case 'Все включено':
          ids.push('vsevklucheno');
          break;
        case 'Без питания':
          ids.push('bezpitania');
          break;
        case 'Завтраки, обеды':
          ids.push('zavtrak_obed');
          break;
        case 'Трехразовое':
          ids.push('trehrazovoe');
          break;
        case 'Завтрак, ужин':
          ids.push('zavtrak_ujin');
          break;
        case 'Завтраки':
        default:
          ids.push('zavtraki');
          break;
      }

      if (this.data.beach_line === 'line_3') ids.push('cityhotel');
      else {
        if (this.data.beach_type === 'sandy_pebble') ids.push('sandpebble');
        else if (this.data.beach_type === 'sandy') ids.push('sand');
        else if (this.data.beach_type === 'pebble') ids.push('pebble');
        if (this.data.beach_line === 'line_1') ids.push('firstline');
        else if (this.data.beach_line === 'line_2') ids.push('secondline');
      }
      if (this.rating > 9) ids.push('best');
      else if (this.rating > 8) ids.push('better');
      else if (this.rating > 7) ids.push('good');

      return ids;
    }
  }
};
</script>

<style scoped>
.wspo-icon-container {
  display: flex;
  padding: 8px;
  flex-wrap: wrap;

  background-color: var(--color-bg-dark);
}

.wspo-icon-sprite {
  background: url('//well.ru/local/modules/well.modules/img/well-spo-sprite.svg');
  background-size: cover;
  display: flex;
  width: 72px;
  height: 72px;
  margin: 4px 12px;
}

.wspo-icon-sprite#zavtraki {
  background-position: calc((-90px * 1)) 72px;
}

.wspo-icon-sprite#vsevklucheno {
  background-position: calc((-90px * 2)) 72px;
}

.wspo-icon-sprite#bezpitania {
  background-position: calc((-90px * 0)) 72px;
}

.wspo-icon-sprite#projivanie {
  background-position: calc((-90px * 3)) 72px;
}

.wspo-icon-sprite#perelet {
  background-position: calc((-90px * 4)) 72px;
}

.wspo-icon-sprite#strahovka {
  background-position: calc((-90px * 5)) 72px;
}

.wspo-icon-sprite#transfer {
  background-position: calc((-90px * 6)) 72px;
}

.wspo-icon-sprite#train {
  background-position: calc((-90px * 7)) 72px;
}

.wspo-icon-sprite#zavtrak_ujin {
  background-position: calc((-90px * 8)) 72px;
}

.wspo-icon-sprite#ekskursii {
  background-position: calc((-90px * 9)) 72px;
}

.wspo-icon-sprite#bus {
  background-position: calc((-90px * 1)) 72px;
}

.wspo-icon-sprite#zavtrak_obed {
  background-position: calc((-90px * 1)) 72px;
}

.wspo-icon-sprite#newyearprogram {
  background-position: calc((-90px * 1)) 72px;
}

.wspo-icon-sprite#rannee {
  background-position: calc((-90px * 1)) 72px;
}

.wspo-icon-sprite#newyear {
  background-position: calc((-90px * 1)) 72px;
}

.wspo-icon-sprite#trehrazovoe {
  background-position: calc((-90px * 1)) 72px;
}

.wspo-icon-sprite#pebble {
  background-position: calc(-90px * 17) 72px;
}

.wspo-icon-sprite#sand {
  background-position: calc(-90px * 18) 72px;
}

.wspo-icon-sprite#firstline {
  background-position: calc(-90px * 19) 72px;
}

.wspo-icon-sprite#secondline {
  background-position: calc(-90px * 20) 72px;
}

.wspo-icon-sprite#cityhotel {
  background-position: calc(-90px * 21) 72px;
}

.wspo-icon-sprite#wifilobbyfree {
  background-position: calc(-90px * 22) 72px;
}

.wspo-icon-sprite#wifipaid {
  background-position: calc(-90px * 23) 72px;
}

.wspo-icon-sprite#wifilobbypaid {
  background-position: calc(-90px * 24) 72px;
}

.wspo-icon-sprite#wifilobby {
  background-position: calc(-90px * 25) 72px;
}

.wspo-icon-sprite#sandpebble {
  background-position: calc(-90px * 26) 72px;
}

.wspo-icon-sprite#aircon {
  background-position: calc(-90px * 27) 72px;
}

.wspo-icon-sprite#good {
  background-position: calc(-90px * 28) 72px;
}

.wspo-icon-sprite#better {
  background-position: calc(-90px * 29) 72px;
}

.wspo-icon-sprite#best {
  background-position: calc(-90px * 30) 72px;
}

.wspo-icon-sprite#wififree {
  background-position: calc(-90px * 31) 72px;
}
</style>
